const translations = {
    invalidAddressErrorMessage: 'Please enter a valid address',
    maxExceededErrorMessage: 'Too many characters',
    requiredErrorMessage: 'This field is required'
};

export default translations;
